import React, { Component } from 'react';
import './App.css';
import Header from './Component/Header'
import Data from './Data/Data.json';
import Hijo from './Component/Hijo';
import NietoFrom from './Component/Nietoform';

class App extends Component {
  
  state = { data:Data }

  addNieto = (user, pass, description) =>{
    const newNieto = {
      user: user,
      pass: pass,
      description: description,      
      id: this.state.data.length
    }
    this.setState({
      data: [...this.state.data, newNieto]
    })
  }  

  deleteNieto = (id) =>{ 
    const newData = this.state.data.filter( nieto => nieto.id !== id );     
    this.setState({data: newData});
   }

  chechState = (id) => {
    const newData = this.state.data.map( nieto => {
      if ( nieto.id === id ) {
        nieto.state = !nieto.state
      }
      return nieto;
    });
    this.setState({ data: newData });
  } 
   
  render(){
    return(
      <div className="body">
        <Header />
        <div className="content">
          <div className="data">
            <div className="addnieto">
              <NietoFrom addNieto={ this.addNieto } data={this.state.data} />
            </div>
            <div className="title-list"> <h2> List Users </h2> </div>
            <div className="r-title">
              <div className="r-t-user">  Users  </div>
              <div className="r-t-pass">  Passwords </div>                    
              <div className="r-t-desciption"> Description </div>
              <div className="r-t-enable"> Enable  </div>
              <div className="r-t-delete" > Delete </div>
              <br/>
            </div>  
            <div className="r-data"> 
              <Hijo className="Hijo" data = { this.state.data } deleteNieto={this.deleteNieto} chechState={this.chechState} /> 
            </div>                
          </div>
        </div> 
      </div>
    )
  }
}

export default App;
